document.addEventListener('DOMContentLoaded', () => {
  const directProductLabels = new Set(['shop', 'shop now', 'shop juicego', 'explore juicego']);
  document.querySelectorAll('a').forEach((link) => {
    if (directProductLabels.has(link.textContent.trim().toLowerCase())) link.href = '/products/juiceit';
  });

  document.querySelectorAll('[data-countdown]').forEach((el) => {
    let remaining = Number(el.dataset.hours || 6) * 3600;
    const render = () => {
      const h = Math.floor(remaining / 3600);
      const m = Math.floor((remaining % 3600) / 60);
      const s = remaining % 60;
      el.textContent = `${h}h : ${String(m).padStart(2, '0')}m : ${String(s).padStart(2, '0')}s`;
      remaining = Math.max(0, remaining - 1);
    };
    render();
    setInterval(render, 1000);
  });

  const menu = document.querySelector('[data-mobile-nav]');
  const toggle = document.querySelector('[data-menu-toggle]');
  toggle?.addEventListener('click', () => {
    const open = menu.classList.toggle('open');
    toggle.setAttribute('aria-expanded', String(open));
  });

  const dialog = document.querySelector('[data-search-dialog]');
  const input = dialog?.querySelector('input');
  document.querySelector('[data-search-open]')?.addEventListener('click', () => { dialog.hidden = false; input?.focus(); });
  document.querySelector('[data-search-close]')?.addEventListener('click', () => { dialog.hidden = true; });
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.hidden = true; });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && dialog && !dialog.hidden) dialog.hidden = true; });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const main = root.querySelector('#juiceGoMainImage');
    const setMainImage = (url) => {
      if (!main || !url) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.srcset = '';
      main.src = url;
    };
    root.querySelectorAll('[data-product-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      setMainImage(thumb.dataset.image);
      root.querySelectorAll('[data-product-thumb]').forEach((item) => item.classList.remove('active'));
      thumb.classList.add('active');
    }));
    const select = root.querySelector('[data-variant-select]');
    select?.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = root.querySelector('[data-product-price]');
      const compare = root.querySelector('[data-compare-price]');
      if (price) price.textContent = option.dataset.price || '';
      if (compare) compare.textContent = option.dataset.compare || '';
      setMainImage(option.dataset.image);
    });
  });
});
